console.log('Formations single script loaded');

document.addEventListener("DOMContentLoaded", function () {
    const sessionsBlock = document.getElementById("next-sessions");
    const formationRightCol = document.querySelector(".single-formation__content-right");

    if (sessionsBlock) {

        if (window.innerWidth > 991) {

            let is_sticky = false;

            const positionFixed = sessionsBlock.getBoundingClientRect().top + window.scrollY;
            const sessionsBlockHeight = sessionsBlock.offsetHeight;

            const pageHeaderHeight = document.querySelector(".single-formation__header").offsetHeight;
            const breadcrumbHeight = document.querySelector(".breadcrumb").offsetHeight;
            const container = document.querySelector(".single-formation__content .container");
            const containerHeight = container.offsetHeight;

            document.addEventListener("scroll", function () {

                const siteHeader = document.querySelector(".site-header");
                const siteHeaderHeight = siteHeader.offsetHeight + 25;
                const fullHeight = pageHeaderHeight + breadcrumbHeight + containerHeight + siteHeaderHeight;

                // console.log("Hauteur du container : " + containerHeight);

                if (window.scrollY + siteHeaderHeight + sessionsBlockHeight - fullHeight > 0) {
                    sessionsBlock.classList.remove("is-fixed");
                    sessionsBlock.classList.add("position-fixed-footer");
                    is_sticky = false;
                }

                if (!is_sticky && positionFixed <= window.scrollY + siteHeaderHeight && window.scrollY + siteHeaderHeight + sessionsBlockHeight - fullHeight < 0) {
                    sessionsBlock.classList.add("position-fixed");
                    sessionsBlock.classList.remove("position-fixed-footer");

                    if (formationRightCol) {
                        formationRightCol.style.position = "relative";
                    }

                    is_sticky = true;

                } else if (is_sticky && positionFixed > window.scrollY + siteHeaderHeight) {
                    sessionsBlock.classList.remove("position-fixed");
                    is_sticky = false;
                }

            });
        }
    }
})